var _excluded = ["passwordParametersPaths"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import { get, isEmpty } from "lodash";
import { format } from "./locales";
var serviceDisplayNames = {
  artifactory: "Artifactory",
  bitbucketgit: "Bitbucket",
  draservicebroker: "DevOps Insights",
  environment: "Environment",
  eventmanagement: "Event Management",
  github_integrated: "GitHub Enterprise Whitewater",
  githubconsolidated: "GitHub",
  githubpublic: "GitHub",
  gitlab: "GitLab",
  hashicorpvault: "HashiCorp Vault",
  hostedgit: "Git Repos and Issue Tracking",
  jenkins: "Jenkins",
  jira: "Jira",
  keyprotect: "Key Protect",
  nexus: "Nexus",
  orion: "Eclipse Orion Web IDE",
  pagerduty: "PagerDuty",
  pipeline: "Delivery Pipeline",
  private_worker: "Delivery Pipeline Private Worker",
  rationalteamconcert: "Rational Team Concert",
  saucelabs: "Sauce Labs",
  secretsmanager: "Secrets Manager",
  security_compliance: "Security and Compliance Center",
  slack: "Slack",
  sonarqube: "SonarQube"
};
var getIntegrationDisplayName = function getIntegrationDisplayName(service) {
  var serviceDisplayName = serviceDisplayNames[service.service_id];
  var _service$parameters = service.parameters,
    label = _service$parameters.label,
    repo_url = _service$parameters.repo_url,
    type = _service$parameters.type;
  var displayName = serviceDisplayName;
  if (service.service_id === "customtool") {
    displayName = "".concat(type, " (").concat(label, ")");
  } else if (service.service_id === "artifactory") {
    displayName = "".concat(displayName, " ").concat(type, " (").concat(label, ")");
  } else if (repo_url) {
    displayName = "".concat(displayName, " (").concat(label, " - ").concat(repo_url, ")");
  } else if (label) {
    displayName = displayName ? "".concat(displayName, " (").concat(label, ")") : label;
  }
  return displayName;
};
var findSelectedIntegration = function findSelectedIntegration(property, toolchainServices) {
  var selected = null;
  if (property.value) {
    selected = toolchainServices.find(function (item) {
      var _item$toolchain_bindi;
      return item.instance_id === property.value || ((_item$toolchain_bindi = item.toolchain_binding) === null || _item$toolchain_bindi === void 0 ? void 0 : _item$toolchain_bindi.name) === property.value;
    });
  }
  return selected;
};
var getIntegrationPropertyDisplayValue = function getIntegrationPropertyDisplayValue(_ref) {
  var i18n = _ref.i18n,
    property = _ref.property,
    toolchainServices = _ref.toolchainServices;
  if (!property.value) {
    return "";
  }
  var selectedIntegration = findSelectedIntegration(property, toolchainServices) || {};
  if (!selectedIntegration) {
    return format(i18n.messages.integrationRemoved, [property.value]);
  }
  var passwordParametersPaths = selectedIntegration.passwordParametersPaths,
    integration = _objectWithoutProperties(selectedIntegration, _excluded);
  if (passwordParametersPaths !== null && passwordParametersPaths !== void 0 && passwordParametersPaths.length) {
    if (!property.path || passwordParametersPaths.some(function (path) {
      return path === property.path || path.indexOf("".concat(property.path, ".")) === 0;
    })) {
      return "**********";
    }
  }
  if (!property.path) {
    return JSON.stringify(integration);
  }
  var value = get(integration, property.path, "");
  return _typeof(value) === "object" ? JSON.stringify(value) : value;
};
var getAllPropNames = function getAllPropNames(properties) {
  if (isEmpty(properties)) {
    return [];
  }
  return properties.map(function (prop) {
    return prop.name;
  });
};
var propertyUtils = {
  findSelectedIntegration: findSelectedIntegration,
  getAllPropNames: getAllPropNames,
  getIntegrationDisplayName: getIntegrationDisplayName,
  getIntegrationPropertyDisplayValue: getIntegrationPropertyDisplayValue
};
export default propertyUtils;